export function rosTopicToStreamName(topic: string): string {
    return topic
        .slice(0, 256) // limit to valid length
        .toLowerCase()
        .replace(/[-_ ]+/g, "_") // replace common delimiters
        .replace(/[^a-z0-9_]+/g, ".") // replace unfriendly characters
        .replace(/^[^a-z]/, ""); // remove unfriendly leading characters
}
